import { Datatable, Flex } from '../index';

const Footer = () => {
  return (
    <Flex className='w-100' alignItems='center' justifyContent='between'>
      <Datatable.PaginationMeta />
      <Datatable.PaginationAction />
      <Datatable.PaginationControls />
    </Flex>
  );
};

export default Footer;
